import { OpenTicketShop } from '@openticket/lib-shop';
import { WaasService } from '../composables/waas';

export interface OpenTicketGlobal {
    Shop?: OpenTicketShop;
    Waas?: WaasService;
}

export function getGlobal(): OpenTicketGlobal {
    const OT = globalThis.OpenTicket || {};

    globalThis.OpenTicket = OT;

    return OT;
}

declare global {
    var OpenTicket: OpenTicket | undefined; // eslint-disable-line vars-on-top,no-var

    interface OpenTicket {
        Shop?: OpenTicketShop;
        Waas?: WaasService;
    }
}
